import {
  DESCRIPTION_INPUT_CLASS,
  FieldLabel,
} from "./descriptionUi";

type Props = {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  hint?: string;
  id?: string;
};

export default function KeyLocationPasswordField({
  value,
  onChange,
  error,
  required = true,
  hint,
  id = "key-location-password",
}: Props) {
  return (
    <div className="min-w-0">
      <FieldLabel htmlFor={id} error={error}>
        {required
          ? "Senha da chave digital (obrigatória)"
          : "Senha da chave digital"}
      </FieldLabel>
      <input
        id={id}
        type="text"
        autoComplete="off"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={
          required ? "Informe a senha de acesso" : "Deixe em branco para manter"
        }
        className={`${DESCRIPTION_INPUT_CLASS} w-full`}
      />
      {hint ? <p className="mt-1 text-xs text-slate-500">{hint}</p> : null}
    </div>
  );
}
